import BaseButtonComponent from "@baseUI/component/button/BaseButtonComponent";

export default class ButtonComponent extends BaseButtonComponent {

    constructor(nameTextures, hitArea = null) {
        super(hitArea)
        this.nameTextures = nameTextures
        this.initialize()
    }

    initialize() {
        const buttonTextures = {}
        buttonTextures.up = PIXI.Texture.from(this.nameTextures.up)
        buttonTextures.down = PIXI.Texture.from(this.nameTextures.down)
        buttonTextures.over = PIXI.Texture.from(this.nameTextures.over)
        buttonTextures.disable = PIXI.Texture.from(this.nameTextures.disable)
        super.init(buttonTextures)

    }

}
